import AppImage from '@/components/ui/AppImage';

interface CertificationBadgeProps {
  name: string
  logo: string
  description: string
}

export default function CertificationBadge({ 
  name, 
  logo, 
  description 
}: CertificationBadgeProps) {
  return (
    <div className="flex items-center gap-4 p-4 bg-muted/30 border border-border rounded-lg">
      <div className="w-16 h-16 bg-background rounded-lg flex items-center justify-center flex-shrink-0">
        <AppImage 
          src={logo}
          alt={`${name} certification logo`}
          className="w-12 h-12 object-contain"
        />
      </div>
      <div>
        <h4 className="text-sm font-bold text-foreground mb-1">{name}</h4>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
    </div>
  )
}